/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
// import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."
import { useDispatch } from "react-redux"
import queryString from "query-string"
import { useEffect, useState } from "react"
import { generatePath, useHistory, useLocation } from "react-router-dom"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { メニューコード } from "../../../constant/menuCode"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import {
  TKubunBunruiInfoRes,
  TMasterKubunListGetReq,
} from "../../../service/master/kubun/TKubun"
import KubunService from "../../../service/master/kubun/kubunService"

/**
 * 区分マスタ一覧
 * @returns
 */

const MasterKubunList = () => {
  const history = useHistory()
  const location = useLocation()

  let gridId = "MasterKubunList_GridId"

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TKubunBunruiInfoRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })
  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TMasterKubunListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TMasterKubunListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )
    try {
      const res = await new KubunService().getKubunBunruiList(
        currentSearchCondition
      )
      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態解除
    }
  }
  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TMasterKubunListGetReq = queryString.parse(location.search)
    set分類名(query.分類名)
    return query
  }
  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TMasterKubunListGetReq => {
    return {
      分類名: 分類名,
      分類コード: 分類コード,
    }
  }
  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TMasterKubunListGetReq
  ) => {
    return {
      分類名: wjCore.isNullOrWhiteSpace(searchCondition.分類名 ?? "")
        ? ""
        : searchCondition.分類名,
      分類コード: wjCore.isNullOrWhiteSpace(searchCondition.分類コード ?? "")
        ? ""
        : searchCondition.分類コード,
    }
  }
  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }
  const clearSearchState = () => {
    set分類名("")
  }
  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)
    // header行に一行追加
    var extraRow = new wjGrid.Row()
    extraRow.allowMerging = true
    var columnHeaders = grid.columnHeaders
    columnHeaders.rows.splice(0, 0, extraRow)

    // ヘッダー行に文言追加
    columnHeaders.columns.forEach((c, index) => {
      c.allowMerging = true
      if (c.binding?.includes("変更可能フラグ")) {
        columnHeaders.setCellData(0, index, "変更可能フラグ")
      } else {
        columnHeaders.setCellData(0, index, c.header)
      }
    })
    grid.formatItem.addHandler(formatItem)
    grid.itemFormatter = (panel, r, c, cell) => {
      if (panel.cellType === wjGrid.CellType.ColumnHeader) {
        cell.style.textAlign = "center"
      }
    }
    grid.refresh()
  }
  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.cells) {
      const cellBinding = e.getColumn().binding
      if (cellBinding !== null && e.getRow().dataIndex !== -1) {
        //削除済フラグの行はreadonly
        if (e.getRow().dataItem.削除フラグ) {
          wjCore.toggleClass(e.cell, "read-only-cell", true)
          return
        }
      }
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)
  //#endregion
  //#region [state]
  const [分類名, set分類名] = useState<string>()
  const [分類コード, set分類コード] = useState<string>()
  //#endregion

  //#region [effect]
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `区分マスタ一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion
  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">区分マスタ一覧</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-90rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="input-group">
                              <TextInput
                                style={{ width: "25rem" }}
                                id="分類名"
                                name="分類名"
                                value={分類名}
                                setValue={async (v) => {
                                  set分類名(v)
                                }}
                                placeholder="分類名"
                              />
                              <TextInput
                                style={{ width: "8rem" }}
                                id="分類コード"
                                name="分類コード"
                                value={分類コード}
                                setValue={async (v) => {
                                  set分類コード(v)
                                }}
                                maxLength={5}
                                placeholder="分類コード"
                              />
                            </div>
                          </div>
                          <div className="search-condition-row">
                            <Button
                              type="submit"
                              disabled={isSearching}
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                search()
                              }}>
                              <FontAwesomeIcon icon={faSearch} />
                              検索
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>

              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}>
                <wjrGrid.FlexGridColumn
                  header="分類コード"
                  allowMerging="true"
                  align="center"
                  width={80}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TKubunBunruiInfoRes>
                    ) => {
                      const url = util.getMenuPath(
                        メニューコード.マスタ管理.区分マスタ登録
                      )[0]
                      return (
                        <a
                          className="text-center text-primary"
                          rel="noreferrer"
                          href={generatePath(url, {
                            id: context.item.区分分類ID,
                          })}
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.区分分類ID.toString()
                              )
                            )
                          }}>
                          {context.item.分類コード}
                        </a>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="分類名"
                  width={200}
                  header="分類名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ソート番号"
                  width={110}
                  header="ソート番号"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分名称1変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="名称1"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分名称2変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="名称2"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分名称3変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="名称3"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分数値1変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="数値1"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分数値2変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="数値2"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分数値3変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="数値3"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分小数値1変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="小数値1"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分小数値2変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="小数値2"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分小数値3変更可能フラグ"
                  width={80}
                  dataType={wjCore.DataType.Boolean}
                  header="小数値3"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分追加可能フラグ"
                  width={100}
                  dataType={wjCore.DataType.Boolean}
                  header="追加可能"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="区分削除可能フラグ"
                  width={100}
                  dataType={wjCore.DataType.Boolean}
                  header="削除可能"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
export default MasterKubunList
